import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { AuthService, ImpersonationService } from '../../services';
import { ImpersonationDialogComponent } from '../impersonation-dialog/impersonation-dialog.component';

@Component({
  selector: 'app-header',
  imports: [ButtonModule, Popover, ImpersonationDialogComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  private readonly authService = inject(AuthService);
  private readonly impersonationService = inject(ImpersonationService);

  appName = 'eDispatch';
  userName = this.authService.getCurrentUserName();
  userEmail = this.authService.getCurrentUserEmail();

  readonly isImpersonationAllowed = this.impersonationService.isAllowed;
  readonly impersonationDialogVisible = signal(false);

  readonly isImpersonating = this.impersonationService.isImpersonating;
  readonly impersonatedUser = this.impersonationService.impersonatedUser;
  readonly impersonatedName = computed(() => this.impersonationService.impersonatedUser()?.fullName ?? '');
  readonly impersonatedLoginId = computed(() => this.impersonationService.impersonatedUser()?.userName ?? '');

  openImpersonationDialog(popover: Popover, event: MouseEvent): void {
    popover.hide();
    event.stopPropagation();
    this.impersonationDialogVisible.set(true);
  }

  stopImpersonating(): void {
    this.impersonationService.stopImpersonation();
  }
}
